import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";

const styles = {
    root: {
        backgroundColor: "rgba(255, 255, 255, 0.42)",
        height: "20px",
        margin: "0 10px",
        width: "1px",
    },
};

export const VariantDivider = withStyles(styles)(Divider);
